var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import * as React from 'react';
import { SvgIcon } from '@mui/material';
function RefreshIconInner(props) {
  return /*#__PURE__*/React.createElement("svg", __assign({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C14.7599 3 17.3124 4.23832 19 6.24687V5C19 4.44772 19.4477 4 20 4C20.5523 4 21 4.44772 21 5V9C21 9.55228 20.5523 10 20 10H19.5529C19.5189 10.0017 19.4849 10.0017 19.4512 10H16C15.4477 10 15 9.55228 15 9C15 8.44772 15.4477 8 16 8H17.8278C16.5365 6.16472 14.3666 5 12 5C8.45881 5 5.4865 7.64454 5.05383 11.1268C4.98573 11.6749 4.48623 12.064 3.93816 11.9959C3.39008 11.9278 3.00099 11.4283 3.06909 10.8802C3.62583 6.39941 7.44656 3 12 3ZM8 16H6.1733C7.46227 17.8366 9.63001 19 12 19C15.5359 19 18.5054 16.3631 18.9444 12.8873C19.0136 12.3393 19.5139 11.9513 20.0618 12.0205C20.6098 12.0897 20.9979 12.59 20.9286 13.1379C20.3637 17.6104 16.5467 21 12 21C9.23689 21 6.68562 19.7626 5 17.7529V19C5 19.5523 4.55228 20 4 20C3.44772 20 3 19.5523 3 19V15C3 14.4477 3.44772 14 4 14H8C8.55228 14 9 14.4477 9 15C9 15.5523 8.55228 16 8 16Z",
    fill: ""
  }));
}
export var RefreshIcon = function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, __assign({
    inheritViewBox: true,
    component: RefreshIconInner
  }, props));
};